import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { selectMediaSummaryForCurrentBib } from 'app/selectors/bibs/EvaluationSelector';
import { MediaSummary } from '.';

export class MediaSummaryContainer extends React.PureComponent {
  render() {
    return <MediaSummary {...this.props} />;
  }
}

MediaSummaryContainer.propTypes = {
  mediaSummary: PropTypes.string
};

const mapStateToProps = state => ({
  mediaSummary: selectMediaSummaryForCurrentBib(state)
});

export default connect(mapStateToProps)(MediaSummaryContainer);
